/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from "react";
import { StatusTag } from "components/StatusTag";
import { AntButton } from "components/AntButton";
import { openZendeskSupportTicket } from "utils/zendesk";
import { AntSwitch } from "../../../components/AntSwitch";
import { STAKING_STATUS } from "constants/stake";
import { ContainerTable, TableView } from "../../../components/Table";
import {
  getUserStakeInfo,
  getStakeEligible,
  getStakeTransactions,
} from "../../../services/app";
import { useApp } from "../../../contexts";
import { CopyIcon } from "../../../components/Icons/CopyIcon";
import { Copy } from "../../../components/Copy";
import {
  SlideBannerContainer,
  SlideBannerOuterContainer,
  SwiperSlideWrapper,
  SwiperWraper,
} from "../../../pages/Home/styles";
import { Tooltip } from "antd";
import { InfoTooltipIcon } from "../../../pages/Home/styles";
import { ContainerTableStakeMobile, TextCellNormal } from "../styles";
import NumberFormat from "react-number-format";
import { CellRowImage } from "../styles";
import { useNavigate } from "react-router-dom";
import {
  DesktopContainer,
  MobileContainer,
} from "../../../components/Container";
import {
  dateFormatNumber,
  formatNumber,
  getCoinCodeImage,
  calculateInterestAmount,
  RoundNumberOfDigitSGT,
} from "../../../utils/helper";
import { useWindowSize } from "../../../hook/useWindowSize";
import { CardSlideHeader } from "../../../components/StakeSlideHeader";
import moment from "moment";
import { WalletRowStake } from "./WalletRowStake";
import { StakingTabIcons } from "../../../components/Icons/StakingTabIcons";
import { FilterIcon } from "../../../components/Icons/FilterIcon";
import { FilterStake } from "./FilterStake";
import { LoadingList } from "../../../components/Loading2";
import EmptyTable from "../../../components/EmptyTable";
import EmptyTableMobile from "../../../components/EmptyTableMobile";
import {
  decimalSeparatorByCurrency,
  thousandSeparatorByCurrency,
} from "../../../utils/Currency";
import useQueryParamState from "hook/useQueryParamState";

const PAGE_SIZES = {
  ACTIVE: 1000,
  HISTORY: 1000,
  CLAIMABLE: 1000,
};

export const STAKE_SUB_TAB = {
  ACTIVE: "active",
  ELIGIBLE: "eligible",
  HISTORY: "history",
  CLAIMABLE: "claimable",
};

export const STAKE_TX_STATUS_OPTIONS = [
  {
    value: "",
    label: "All",
    displayClassName: "",
  },
  // {
  //   value: STAKE_TX_STATUS.PENDING,
  //   label: "Pending",
  //   displayClassName: "stake-status-pending",
  // },
  // {
  //   value: STAKE_TX_STATUS.SUCCESS,
  //   label: "Success",
  //   displayClassName: "stake-status-success",
  // },
  {
    value: STAKING_STATUS.HOLDING,
    label: "Staking",
    displayClassName: "stake-status-holding",
  },
  {
    value: STAKING_STATUS.REDEEMED,
    label: "Staking finished",
    displayClassName: "stake-status-redeemed",
  },
  {
    value: STAKING_STATUS.CLAIM_IN_PROGRESS,
    label: "Claim in progress",
    displayClassName: "stake-status-claim-in-progress",
  },
  {
    value: STAKING_STATUS.CLAIMED,
    label: "Claim success",
    displayClassName: "stake-status-claimed",
  },
  {
    value: STAKING_STATUS.CLAIM_FAILED,
    label: "Claim failed",
    displayClassName: "stake-status-claim-failed",
  },
  {
    value: STAKING_STATUS.FAILED,
    label: "Stake Failed",
    displayClassName: "stake-status-failed",
  },
];

const SORT_BY = {
  amount: "amount",
  startTime: "start_date",
  claimTime: "end_date",
};

const SORT_TYPE = {
  ascend: "asc",
  descend: "desc",
};

const sortStakeTransactions = (list) => {
  const STATUS_PRIORITY = {
    [STAKING_STATUS.REDEEMED]: 0,
    [STAKING_STATUS.CLAIM_FAILED]: 1,
    [STAKING_STATUS.FAILED]: 2,
    [STAKING_STATUS.HOLDING]: 3,
    [STAKING_STATUS.CLAIMED]: 4,
  };

  return [...(list || [])].sort((a, b) => {
    const statusOrderA = STATUS_PRIORITY[a?.status] ?? Number.MAX_SAFE_INTEGER;
    const statusOrderB = STATUS_PRIORITY[b?.status] ?? Number.MAX_SAFE_INTEGER;

    if (statusOrderA !== statusOrderB) {
      return statusOrderA - statusOrderB;
    }

    const endDateA = a?.end_date ? new Date(a.end_date).getTime() : 0;
    const endDateB = b?.end_date ? new Date(b.end_date).getTime() : 0;

    return endDateB - endDateA;
  });
};

export const StakeForOptionTable = () => {
  const { T, loading, language, getCurrency, user } = useApp();
  const navigate = useNavigate();
  const size = useWindowSize();
  const isMobile = size.width < 768;

  const [rows, setRows] = useState([]);
  const [viewEligibleOnly, setViewEligibleOnly] = useState(true);
  const [stats, setStats] = useState({
    stakedBalance: 0,
    availableBalance: 0,
    claimableBalance: 0,
  });
  const [viewType, setViewType] = useQueryParamState(
    "type",
    STAKE_SUB_TAB.ACTIVE
  );
  const [showFilter, setShowFilter] = useState(false);
  const [filterParams, setFilterParams] = useState({});
  const [tabLoading, setTabLoading] = useState(false);
  const [tableLoading, setTableLoading] = useState(false);
  const [tableKey, setTableKey] = useState(0);
  const swiperRef = React.useRef(null);

  useEffect(() => {
    if (swiperRef.current && swiperRef.current.swiper) {
      const viewIndex = [
        STAKE_SUB_TAB.ACTIVE,
        STAKE_SUB_TAB.ELIGIBLE,
        STAKE_SUB_TAB.CLAIMABLE,
      ].indexOf(viewType);
      if (viewIndex !== -1) {
        // swiperRef.current.swiper.slideTo(viewIndex);
      }
    }
  }, [viewType]);

  useEffect(() => {
    loadTabList();
    getUserStakeInfo().then((res) => {
      const data = res?.data;
      setStats(data);
    });
  }, [viewType]);

  const loadTabList = async () => {
    try {
      setTabLoading(true);
      await loadData();
    } catch (e) {
    } finally {
      setTabLoading(false);
    }
  };

  const handleSearch = () => {
    loadData();
  };

  const handleTableChange = (pagination, filters, sorter) => {
    const { order, field } = sorter;
    setFilterParams({
      ...filterParams,
      sortBy: field,
      sortType: order,
    });
    loadData();
  };

  const handleReset = () => {
    setFilterParams({});
    setTableKey(tableKey + 1);
    loadData();
  };

  const handleViewTypeChange = (val) => {
    if (viewType === val) return;

    setRows([]);
    setFilterParams({});
    setShowFilter(false);
    setViewType(val);
  };

  const onChangeSwitch = (checked) => {
    setViewEligibleOnly(checked);
  };

  const toggleFilter = () => {
    setShowFilter(!showFilter);
  };

  const getSpaceBetween = () => {
    let distance = 30;
    if (size.width < 1024) {
      distance = 20;
    }
    return distance;
  };

  const formatFromDateParam = (date) => {
    return date ? moment(date).startOf("day").toISOString() : null;
  };

  const formatToDateParam = (date) => {
    return date ? moment(date).endOf("day").toISOString() : null;
  };

  const navigateToStakeDetail = (stake) => {
    if (viewType === STAKE_SUB_TAB.ELIGIBLE) {
      return;
    }
    const searchParams = new URLSearchParams();
    searchParams.set("stakeRecordId", stake?.stakeRecordId);
    navigate(`/stake-by-option-detail?${searchParams.toString()}`);
  };

  const getDesktopRowProps = (record) => ({
    onClick: () => navigateToStakeDetail(record),
  });

  const fetchDataActive = async ({ page }) => {
    const params = {
      transactionId: filterParams?.transactionId,
      endDateFrom: formatFromDateParam(filterParams?.endDateRange?.[0]),
      endDateTo: formatToDateParam(filterParams?.endDateRange?.[1]),
      startDateFrom: formatFromDateParam(filterParams?.startDateRange?.[0]),
      startDateTo: formatToDateParam(filterParams?.startDateRange?.[1]),
      sortBy: SORT_BY[filterParams?.sortBy] ?? SORT_BY.claimTime,
      sortType: SORT_TYPE[filterParams?.sortType] ?? SORT_TYPE.ascend,
      pageSize: PAGE_SIZES.ACTIVE,
      page: page,
    };

    try {
      const res = await getStakeTransactions(params);
      const result = sortStakeTransactions(res?.data?.records);
      return result;
    } catch (err) {
      console.log("TableStake -> fetchDataActive -> err", err);
    }
  };

  const fetchDataEligible = async () => {
    const res = await getStakeEligible();
    return res?.data;
  };

  const fetchDataClaimable = async ({ page }) => {
    const params = {
      pageSize: PAGE_SIZES.CLAIMABLE,
      page: page,
    };

    try {
      const res = await getStakeTransactions(params);
      const claimableRecords = res?.data?.records.filter((item) => [STAKING_STATUS.REDEEMED, STAKING_STATUS.CLAIM_IN_PROGRESS, STAKING_STATUS.CLAIM_FAILED].includes(item.status));
      const result = sortStakeTransactions(claimableRecords);
      const formatedResult = result.map((item) => {
        return {
          ...item,
          claimableAmount: isNaN(Number(item.amount))
            ? 0
            : Number(item.amount) +
              calculateInterestAmount(item.amount, item.interestRate),
        };
      });
      return formatedResult;
    } catch (err) {
      console.log("TableStake -> fetchDataActive -> err", err);
    }
  };

  const loadData = async (page = 1) => {
    try {
      setTableLoading(true);
      let result = null;

      switch (viewType) {
        case STAKE_SUB_TAB.ACTIVE: {
          result = await fetchDataActive({ page });
          break;
        }
        case STAKE_SUB_TAB.ELIGIBLE: {
          result = await fetchDataEligible();
          break;
        }
        case STAKE_SUB_TAB.CLAIMABLE: {
          result = await fetchDataClaimable({ page });
          break;
        }
        default:
          break;
      }

      if (result && Array.isArray(result)) {
        const items = result.map((item, index) => ({
          ...item,
          key:
            item.stakeRecordId ||
            `${item.txHash}-${item.status}` ||
            item.transactionId ||
            `${item.name || "item"}-${index}`,
        }));
        setRows(items);
      } else {
        setRows([]);
      }
    } catch (err) {
      console.log(err);
      setRows([]);
    } finally {
      setTableLoading(false);
    }
  };

  const rowsToView = useMemo(() => {
    if (viewType === STAKE_SUB_TAB.ELIGIBLE) {
      if (viewEligibleOnly) {
        return (rows || []).filter((record) => {
          return (
            moment(new Date()).isAfter(new Date(record.validStakeTimeFrom)) &&
            moment(new Date()).isBefore(new Date(record.validStakeTimeTo)) &&
            record.remainAmount > 0
          );
        });
      }
      return rows;
    }
    return rows;
  }, [rows, viewEligibleOnly, viewType]);

  const ACTION_COLUMN = {
    title: T("Action"),
    dataIndex: "action",
    key: "action",
    align: "center",
    width: 100,
    render: (text, record, index) => {
      const hasActions = [
        STAKING_STATUS.REDEEMED,
        STAKING_STATUS.CLAIM_FAILED,
      ].includes(record.status);
      if (!hasActions) return null;
      const handleClickReStake = (e) => {
        e.stopPropagation();
        const searchParams = new URLSearchParams();
        searchParams.set("stakeRecordId", record.stakeRecordId);
        searchParams.set("txHash", record.txHash);
        navigate(`/re-stake-request?${searchParams.toString()}`);
      };

      const handleClickClaim = (e) => {
        e.stopPropagation();
        const searchParams = new URLSearchParams();
        searchParams.set(
          "stakeRecordId",
          encodeURIComponent(record.stakeRecordId)
        );
        navigate(`/claim-staking-request?${searchParams.toString()}`, {
          state: { stakeData: record },
        });
      };

      const handleClickRetryClaim = (e) => {
        e.stopPropagation();
        navigate(
          `/claim-staking-request?stakeRecordId=${record.stakeRecordId}`
        );
      };

      const handleClickGetSupport = (e) => {
        e.stopPropagation();
        openZendeskSupportTicket({
          language,
          userEmail: user?.email ?? "",
          issueType: "app_issues",
          subject: `Stake for Option issue: ${record.stakeRecordId}`,
          description: `- Transaction hash: ${record.txHash}`,
        });
      };
      return (
        <div
          className="flex gap-2 justify-start align-center"
          onClick={(e) => e.stopPropagation()}
        >
          {record.status === STAKING_STATUS.REDEEMED && (
            <>
              <AntButton
                type="button"
                variant="outline"
                onClick={handleClickClaim}
                className="w-1/2 min-w-[105px]"
              >
                {T("Claim")}
              </AntButton>
              <AntButton
                type="button"
                variant="primary"
                onClick={handleClickReStake}
                className="w-1/2 min-w-[105px]"
              >
                {T("Re-stake")}
              </AntButton>
            </>
          )}
          {record.status === STAKING_STATUS.CLAIM_FAILED &&
            !(record?.claimAttempts >= 2) && (
              <AntButton
                type="button"
                variant="outline"
                className="w-[calc(50%-8px)] min-w-[105px]"
                onClick={handleClickRetryClaim}
              >
                {T("Retry Claim")}
              </AntButton>
            )}
        </div>
      );
    },
  };

  const STAKE_OPTION_COLUMNS = {
    ACTIVE: [
      {
        title: T("Stake Amount"),
        dataIndex: "amount",
        key: "amount",
        align: "right",
        className: "justify-end min-w-[158px]",
        fixed: "left",
        sorter: true,
        render: (text, record, index) => (
          <TextCellNormal>
            <NumberFormat
              value={record.amount}
              displayType={"text"}
              thousandSeparator={thousandSeparatorByCurrency(getCurrency())}
              decimalSeparator={decimalSeparatorByCurrency(getCurrency())}
              suffix={` ${record.tokenName}`}
              decimalScale={3}
            />
          </TextCellNormal>
        ),
      },
      {
        title: T("Start date"),
        dataIndex: "startTime",
        key: "startTime",
        align: "center",
        fixed: "left",
        className: "justify-center min-w-[140px]",
        sorter: true,
        render: (text, record, index) => (
          <TextCellNormal>
            {dateFormatNumber(text, "YYYY/MM/DD")}
          </TextCellNormal>
        ),
      },
      {
        title: T("Duration"),
        dataIndex: "duration",
        key: "duration",
        align: "right",
        className: "min-w-[80px]",
        render: (text, record, index) => (
          <TextCellNormal>
            <span className="capitalize whitespace-nowrap">
              {record.duration}{" "}
              {record.duration > 1
                ? T(record.durationUnit + "s")
                : T(record.durationUnit)}
            </span>
          </TextCellNormal>
        ),
      },
      {
        title: T("Interest rate"),
        dataIndex: "interestRate",
        key: "interestRate",
        align: "right",
        className: "min-w-[80px]",
        render: (text, record, index) => (
          <TextCellNormal>{formatNumber(+text)}%</TextCellNormal>
        ),
      },
      {
        title: T("Interest Amount"),
        dataIndex: "estReward",
        key: "estReward",
        align: "right",
        className: "min-w-[180px]",
        render: (text, record, index) => (
          <TextCellNormal>
            <NumberFormat
              className="text-[#F12E11] font-semibold no-wrap"
              value={calculateInterestAmount(
                record?.amount,
                record?.interestRate
              )}
              displayType="text"
              thousandSeparator={thousandSeparatorByCurrency(getCurrency())}
              decimalSeparator={decimalSeparatorByCurrency(getCurrency())}
              decimalScale={2}
              suffix=" SGT"
            ></NumberFormat>
          </TextCellNormal>
        ),
      },
      // Status
      {
        title: T("Status"),
        dataIndex: "status",
        key: "status",
        align: "center",
        width: 100,
        render: (text, record, index) => {
          return <StatusTag status={record.status} />;
        },
      },
      // Action
      ACTION_COLUMN,
    ],
    ELIGIBLE: [
      {
        title: T("Token"),
        dataIndex: "name",
        key: "name",
        width: 110,
        render: (text, record, index) => {
          return (
            <CellRowImage style={{ minWidth: 60 }}>
              <img
                alt=""
                style={{ width: 28, height: 28 }}
                src={`/assets/images/otc/crypto/${getCoinCodeImage(
                  text
                )?.toLowerCase()}.svg`}
              />
              <span style={{ marginLeft: 16 }}>{text}</span>
            </CellRowImage>
          );
        },
      },
      {
        title: T("Description"),
        dataIndex: "description",
        key: "description",
        align: "center",
        width: 160,
        render: (text, record) => (
          <TextCellNormal className="leading-6">
            {record.name === "SGT"
              ? T("Walking_reward") + ` ${record.description}`
              : ""}
            {record.name === "SOTa"
              ? T("Released") + ` ${record.description}`
              : ""}
          </TextCellNormal>
        ),
      },
      {
        title: T("Exchange amount"),
        dataIndex: "exercisedAmount",
        key: "exercisedAmount",
        align: "center",
        width: 160,
        render: (text, record, index) => (
          <TextCellNormal>
            <NumberFormat
              value={record.exercisedAmount}
              displayType={"text"}
              thousandSeparator={thousandSeparatorByCurrency(
                record.stakeCurrency || "SGT"
              )}
              decimalSeparator={decimalSeparatorByCurrency(
                record.stakeCurrency || "SGT"
              )}
              suffix={` ${record.stakeCurrency || "SGT"}`}
              decimalScale={3}
            />
          </TextCellNormal>
        ),
      },
      {
        title: T("Staking Amount"),
        dataIndex: "stakedAmount",
        key: "stakedAmount",
        align: "center",
        width: 160,
        render: (text, record, index) => (
          <TextCellNormal>
            <NumberFormat
              value={record.stakedAmount}
              displayType={"text"}
              thousandSeparator={thousandSeparatorByCurrency(
                record.stakeCurrency || "SGT"
              )}
              decimalSeparator={decimalSeparatorByCurrency(
                record.stakeCurrency || "SGT"
              )}
              suffix={` ${record.stakeCurrency || "SGT"}`}
              decimalScale={3}
            />
          </TextCellNormal>
        ),
      },
      {
        title: (
          <div className="flex items-center justify-center">
            {T("Remain amount")}{" "}
            <Tooltip
              trigger={size.width < 768 ? "click" : "hover"}
              onClick={(e) => e.stopPropagation()}
              className="cursor-pointer mx-[5px]"
              color={"#EAF2FF"}
              overlayClassName={"note-tooltip-10"}
              title={
                <div>
                  <div>
                    {T(
                      "The remaining amount represents the eligible quantity that can be staked in the option."
                    )}
                  </div>
                  <div>{T("This value is determined based on:")}</div>
                  <ul className="list-disc pl-6">
                    <li>{T("User's exercised tokens")}</li>
                    <li>{T("The tokens currently staked")}</li>
                    <li>
                      {T(
                        "The amount that falls within the eligible staking period for that specific token."
                      )}
                    </li>
                  </ul>
                </div>
              }
            >
              <span>
                <InfoTooltipIcon />
              </span>
            </Tooltip>
          </div>
        ),
        dataIndex: "remainAmount",
        key: "remainAmount",
        align: "center",
        width: 160,
        render: (text, record, index) => (
          <TextCellNormal>
            <NumberFormat
              value={record.remainAmount}
              displayType={"text"}
              thousandSeparator={thousandSeparatorByCurrency(
                record.stakeCurrency || "SGT"
              )}
              decimalSeparator={decimalSeparatorByCurrency(
                record.stakeCurrency || "SGT"
              )}
              suffix={` ${record.stakeCurrency || "SGT"}`}
              decimalScale={3}
            />
          </TextCellNormal>
        ),
      },
      {
        title: T("Eligible from"),
        dataIndex: "validStakeTimeFrom",
        key: "validStakeTimeFrom",
        align: "center",
        width: 150,
        render: (text, record, index) => (
          <TextCellNormal>
            <div className="flex justify-center mx-auto w-[100px]">
              <span className="whitespace-break-spaces  leading-6">
                {dateFormatNumber(
                  record.validStakeTimeFrom,
                  "YYYY/MM/DD HH:mm:ss"
                )}
              </span>
            </div>
          </TextCellNormal>
        ),
      },
      {
        title: T("Eligible to"),
        dataIndex: "validStakeTimeFrom",
        key: "validStakeTimeFrom",
        align: "center",
        width: 150,
        render: (text, record, index) => (
          <TextCellNormal>
            <div className="flex justify-center mx-auto w-[100px]">
              <span className="whitespace-break-spaces leading-6">
                {dateFormatNumber(
                  record.validStakeTimeTo,
                  "YYYY/MM/DD HH:mm:ss"
                )}
              </span>
            </div>
          </TextCellNormal>
        ),
      },
      {
        title: T("Status"),
        dataIndex: "releaseOn",
        key: "releaseOn",
        align: "center",
        width: 100,
        render: (text, record, index) => {
          if (
            moment(new Date()).isBefore(new Date(record.validStakeTimeFrom))
          ) {
            return <TextCellNormal>{T("Incoming")}</TextCellNormal>;
          } else if (
            moment(new Date()).isAfter(new Date(record.validStakeTimeFrom)) &&
            moment(new Date()).isBefore(new Date(record.validStakeTimeTo))
          ) {
            if (record.remainAmount === 0)
              return <TextCellNormal>{T("Fully Stake")}</TextCellNormal>;
            if (record.remainAmount > 0)
              return (
                <TextCellNormal>
                  <span className="text-[#0F8ACB]">{T("Eligible")}</span>
                </TextCellNormal>
              );
          } else {
            if (record.remainAmount === 0)
              return <TextCellNormal>{T("Fully Stake")}</TextCellNormal>;
            return (
              <TextCellNormal>
                <span className="text-[#E6665C] leading-6">
                  {T("Ineligible")}
                </span>
              </TextCellNormal>
            );
          }
        },
      },
    ],
  };

  const columns = useMemo(() => {
    if (loading) return [];
    switch (viewType) {
      case STAKE_SUB_TAB.ACTIVE:
        return STAKE_OPTION_COLUMNS.ACTIVE;
      case STAKE_SUB_TAB.ELIGIBLE:
        return STAKE_OPTION_COLUMNS.ELIGIBLE;
      case STAKE_SUB_TAB.CLAIMABLE:
        return STAKE_OPTION_COLUMNS.ACTIVE;
      default:
        return [];
    }
  }, [viewType, language, loading]);

  const onCreateStake = () => {
    navigate("/stake-request");
  };

  const headerTitle = useMemo(() => {
    switch (viewType) {
      case STAKE_SUB_TAB.ACTIVE:
        return T("Active Staking Balance");
      case STAKE_SUB_TAB.ELIGIBLE:
        return T("Eligible Staking Balance");
      default:
        return "";
    }
  }, [viewType, T]);

  const renderSlideBanner = () => {
    return (
      <div className="flex justify-start mt-[14px] lg:mt-[24px] flex-wrap lg:flex-nowrap">
        <SlideBannerOuterContainer>
          <SlideBannerContainer className="gap-[16px] showOver">
            <SwiperWraper
              ref={swiperRef}
              slidesPerView="auto"
              spaceBetween={getSpaceBetween()}
              grabCursor={true}
              pagination={false}
              watchOverflow={true}
              onSwiper={(s) => {}}
            >
              <SwiperSlideWrapper key={1}>
                <CardSlideHeader
                  isMobile={isMobile}
                  onClick={() => handleViewTypeChange(STAKE_SUB_TAB.ACTIVE)}
                  active={viewType === STAKE_SUB_TAB.ACTIVE}
                  title={T(`Active Staking Balance`)}
                  balance={`${RoundNumberOfDigitSGT(stats?.stakedBalance)} SGT`}
                  bannerIcon={StakingTabIcons.ACTIVE_BALANCE}
                />
              </SwiperSlideWrapper>
              <SwiperSlideWrapper key={2}>
                <CardSlideHeader
                  isMobile={isMobile}
                  onClick={() => handleViewTypeChange(STAKE_SUB_TAB.ELIGIBLE)}
                  active={viewType === STAKE_SUB_TAB.ELIGIBLE}
                  title={`Eligible Staking Balance`}
                  balance={`${RoundNumberOfDigitSGT(
                    stats?.availableBalance
                  )} SGT`}
                  bannerIcon={StakingTabIcons.ELIGIBLE_BALANCE}
                />
              </SwiperSlideWrapper>
              <SwiperSlideWrapper key={3}>
                <CardSlideHeader
                  isMobile={isMobile}
                  onClick={() => handleViewTypeChange(STAKE_SUB_TAB.CLAIMABLE)}
                  active={viewType === STAKE_SUB_TAB.CLAIMABLE}
                  title={T("Claimable Balance")}
                  balance={`${RoundNumberOfDigitSGT(
                    stats?.claimableBalance ?? 0
                  )} SGT`}
                  bannerIcon={StakingTabIcons.CLAIMABLE_BALANCE}
                />
              </SwiperSlideWrapper>
            </SwiperWraper>
          </SlideBannerContainer>
        </SlideBannerOuterContainer>

        <div className="flex justify-end w-full">
          <button
            type="button"
            className="bg-black text-[16px] rounded-[10px] font-semibold min-w-full lg:min-w-[130px] h-[50px] mt-[30px] lg:mt-0"
            onClick={onCreateStake}
          >
            <span className="text-white">{T("Stake")}</span>
          </button>
        </div>
      </div>
    );
  };

  const renderHeader = () => {
    return (
      <>
        <div className="flex items-center justify-end lg:justify-between lg:pt-[40px] pt-[15px]">
          <div className="hidden lg:block text-[20px] font-semibold">
            {headerTitle}
          </div>

          {[STAKE_SUB_TAB.ACTIVE].includes(viewType) && (
            <>
              <div
                className={`flex justify-center items-center px-[14px] py-[10px] 
                  bg-white gap-[8px] rounded-full lg:rounded-[10px] cursor-pointer`}
                onClick={toggleFilter}
              >
                <span>
                  {" "}
                  <FilterIcon />{" "}
                </span>
                <span className={`text-sm text-black`}>{T("Filter")}</span>
              </div>
            </>
          )}

          {viewType === STAKE_SUB_TAB.ELIGIBLE && (
            <div className="flex justify-end pt-5 lg:pt-[40px] items-center gap-1">
              <span>{T("Show eligible token only")}</span>
              <AntSwitch
                size="small"
                checked={viewEligibleOnly}
                onChange={onChangeSwitch}
              />
            </div>
          )}
        </div>

        <FilterStake
          show={showFilter}
          isMobile={isMobile}
          viewType={viewType}
          filterParams={filterParams}
          onUpdate={setFilterParams}
          onSearch={handleSearch}
          onReset={handleReset}
          onClose={() => {
            setShowFilter(false);
          }}
        />
      </>
    );
  };

  const renderList = () => {
    return (
      <div className="mt-[20px] lg:mt-[20px]">
        <DesktopContainer>
          <ContainerTable>
            <TableView
              key={tableKey}
              locale={{ emptyText: <EmptyTable T={T} /> }}
              scroll={{ x: true }}
              tableLayout={"fixed"}
              pagination={false}
              dataSource={rowsToView}
              columns={columns}
              loading={tableLoading}
              isClickRow
              onRow={getDesktopRowProps}
              onChange={handleTableChange}
            />
          </ContainerTable>
        </DesktopContainer>

        <MobileContainer>
          {tableLoading ? (
            <>{renderReloadingIcon()}</>
          ) : (
            <>
              {rowsToView?.length ? (
                rowsToView?.map((item, index) => (
                  <ContainerTableStakeMobile key={item.key || index}>
                    <WalletRowStake
                      viewType={viewType}
                      item={item}
                      onClick={() => navigateToStakeDetail(item)}
                    />
                  </ContainerTableStakeMobile>
                ))
              ) : (
                <div className="w-full flex justify-center pt-[10px]">
                  <EmptyTableMobile T={T} />
                </div>
              )}
            </>
          )}
        </MobileContainer>
      </div>
    );
  };

  const renderReloadingIcon = () => {
    return (
      <div className="w-full flex justify-center pt-6">
        <LoadingList />
      </div>
    );
  };

  return (
    <>
      {renderSlideBanner()}
      {renderHeader()}
      {tabLoading ? renderReloadingIcon() : renderList()}
    </>
  );
};
